import { ClipboardDocumentIcon } from "@heroicons/react/24/outline";

import { copyToClipboard } from "../../utils";
import { showToast } from "../../utils/toast";

interface CopyButtonProps {
  toastMessage?: string;
  textToCopy: string;
}

const CopyButton = ({
  textToCopy,
  toastMessage = "Copied to Clipboard",
}: CopyButtonProps) => {
  return (
    <button
      type="button"
      onClick={async () => {
        await copyToClipboard(textToCopy, () =>
          showToast(toastMessage, "info"),
        );
      }}
      aria-label="Copy to clipboard"
      className="text-gray-500 transition-colors hover:text-primary"
    >
      <ClipboardDocumentIcon className="h-5 w-5" />
    </button>
  );
};

export default CopyButton;
